import { Layout } from 'antd';
import ChatBox from 'components/ChatBox';
import CircularProgress from 'components/CircularProgress';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
} from '../../constants/ThemeSetting';
import { RootState } from '../../redux/types';
import App from '../../routes';
import Sidebar from '../Sidebar';
import Topbar from '../Topbar';
// import AboveHeader from '../Topbar/AboveHeader';
// import BelowHeader from '../Topbar/BelowHeader';
// import HorizontalDark from '../Topbar/HorizontalDark';
// import HorizontalDefault from '../Topbar/HorizontalDefault';
// import InsideHeader from '../Topbar/InsideHeader';
import NoHeaderNotification from '../Topbar/NoHeaderNotification';
import NoLocationWarningModal from './NoLocationWarningModal';

const { Content, Footer } = Layout;

const MainApp: React.FC = () => {
  const { navStyle } = useSelector<RootState, RootState['settings']>(({ settings }) => settings);
  const match = useRouteMatch();

  const getContainerClass = (inputNavStyle: string) => {
    switch (inputNavStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return 'gx-container-wrap';
      case NAV_STYLE_BELOW_HEADER:
        return 'gx-container-wrap';
      case NAV_STYLE_ABOVE_HEADER:
        return 'gx-container-wrap';
      default:
        return '';
    }
  };
  const getNavStyles = (inputNavStyle: string) => {
    switch (inputNavStyle) {
      // case NAV_STYLE_DEFAULT_HORIZONTAL:
      //   return <HorizontalDefault />;
      // case NAV_STYLE_DARK_HORIZONTAL:
      //   return <HorizontalDark />;
      // case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
      //   return <InsideHeader />;
      // case NAV_STYLE_ABOVE_HEADER:
      //   return <AboveHeader />;
      // case NAV_STYLE_BELOW_HEADER:
      //   return <BelowHeader />;
      case NAV_STYLE_FIXED:
        return <Topbar />;
      case NAV_STYLE_DRAWER:
        return <Topbar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };

  const observeHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  };

  React.useEffect(() => {
    window.addEventListener('resize', observeHeight);
    observeHeight();

    return () => {
      window.removeEventListener('resize', observeHeight);
    };
  }, []);
  const { userFetchLoading, role } = useCurrentLoggedInUser();

  if (userFetchLoading && !role) return <CircularProgress />;
  return (
    <>
      <NoLocationWarningModal />
      <Layout className='gx-app-layout'>
        <Sidebar />
        <Layout>
          {getNavStyles(navStyle)}
          <Content className={`gx-layout-content ${getContainerClass(navStyle)}`}>
            <App match={match} />
          </Content>
          <Footer>
            <div className='chatbox-wrapper'>
              <ChatBox />
            </div>
            <div className='gx-layout-footer-content'>Copyright NotarizeMe © 2021</div>
          </Footer>
        </Layout>
      </Layout>
    </>
  );
};

export default MainApp;
